var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "prvw" }, [
    _c("div", { staticClass: "bg-header", style: _vm.navStyle }),
    _vm._v(" "),
    _c("div", { staticClass: "container n-mx" }, [
      _c("div", { staticClass: "lft" }, [
        _c("span", { staticClass: "logo" }, [
          _vm.logo
            ? _c("img", { attrs: { src: _vm.logo, alt: "brand logo" } })
            : _c("img", {
                attrs: { src: "/img/logo_name.svg", alt: "brand logo" },
              }),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "lnks" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.Global.mockupConfig.content.vod
            ? _c("li", [
                _c("span", { staticClass: "ico" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Video On Demand")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Global.mockupConfig.content.live
            ? _c("li", [
                _c("span", { staticClass: "ico" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Live 24x7")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Global.mockupConfig.content.events
            ? _c("li", [
                _c("span", { staticClass: "ico" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Live Events")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Global.mockupConfig.content.replay
            ? _c("li", [
                _c("span", { staticClass: "ico" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [
                  _vm._v("Start Over & Replay"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.Global.mockupConfig.content.podcast
            ? _c("li", [
                _c("span", { staticClass: "ico" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Podcast")]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", { staticClass: "socials" }, [
          _c("li", [
            _c(
              "svg",
              {
                attrs: {
                  width: "30",
                  height: "30",
                  viewBox: "0 0 30 30",
                  fill: "none",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    opacity: "0.01",
                    width: "30",
                    height: "30",
                    fill: "#D8D8D8",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M22 12V12C22 17.523 17.523 22 12 22V22C6.47703 22 2 17.523 2 12V12C2 6.47703 6.47703 2 12 2V2C17.523 2 22 6.47703 22 12Z",
                    stroke: "white",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M19.5 19.5L23.5 23.5",
                    stroke: "white",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M23 23L26.3284 26.3284",
                    stroke: "white",
                    "stroke-width": "5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "svg",
              {
                attrs: {
                  width: "30",
                  height: "30",
                  viewBox: "0 0 30 30",
                  fill: "none",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    opacity: "0.01",
                    width: "30",
                    height: "30",
                    fill: "#D8D8D8",
                  },
                }),
                _vm._v(" "),
                _c("circle", {
                  attrs: {
                    cx: "15.5",
                    cy: "9.5",
                    r: "8.25",
                    fill: "white",
                    stroke: "white",
                    "stroke-width": "2.5",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M3 19.3502C3 18.1499 4.27981 16.9603 5 16C5.93746 14.7501 6 14 6 13C6 12.222 12.0531 14.4706 14.7405 15.5072C15.5035 15.8015 16 16.5363 16 17.3541V23H5C3.89543 23 3 22.1046 3 21V19.3502Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M28 19.3502C28 18.1499 26.7202 16.9603 26 16C25.0625 14.7501 25 14 25 13C25 12.222 18.9469 14.4706 16.2595 15.5072C15.4965 15.8015 15 16.5363 15 17.3541V23H26C27.1046 23 28 22.1046 28 21V19.3502Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M11.75 25C11.75 27.0711 13.4289 28.75 15.5 28.75C17.5711 28.75 19.25 27.0711 19.25 25",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("rect", {
                  attrs: {
                    x: "6",
                    y: "10",
                    width: "19",
                    height: "10",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "active" }, [
      _c("span", { staticClass: "ico" }),
      _vm._v(" "),
      _c("span", { staticClass: "txt" }, [_vm._v("Home")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "ico" }),
      _vm._v(" "),
      _c("span", { staticClass: "txt" }, [_vm._v("Favorites")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }